const removeLeadingZeros = day => "" + (parseInt(day) || "");

export const dateQueryStringParser = (dateString = "") => {
  const [day = "", month = "", year = ""] = dateString.split("-");
  return {
    day: removeLeadingZeros(day),
    month: removeLeadingZeros(month),
    year,
  };
};